/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOauthGrantRequest
 */
export interface GetOauthGrantRequest {
    /**
     * 
     * @type {string}
     * @memberof GetOauthGrantRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof GetOauthGrantRequest
     */
    clientId: string;
}

/**
 * Check if a given object implements the GetOauthGrantRequest interface.
 */
export function instanceOfGetOauthGrantRequest(value: object): value is GetOauthGrantRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function GetOauthGrantRequestFromJSON(json: any): GetOauthGrantRequest {
    return GetOauthGrantRequestFromJSONTyped(json, false);
}

export function GetOauthGrantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOauthGrantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'clientId': json['client_id'],
    };
}

export function GetOauthGrantRequestToJSON(json: any): GetOauthGrantRequest {
    return GetOauthGrantRequestToJSONTyped(json, false);
}

export function GetOauthGrantRequestToJSONTyped(value?: GetOauthGrantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'client_id': value['clientId'],
    };
}

